const theme = {
  colors: {
    black: "#0C2538",
    blue: "#3B53A2",
    darkblue: "#0C2538",
    yellow: "#EDC411",
    white: "#FFF",
    grey: "#979797",
    lightGrey: "#EDEDED",
    red: "#CC0E0E",
    beige: "#F5F5DC",
    brown: "brown",
    green: "green",
    purple: "purple",
    gold: "#FFD700",
    orange: "#D89A29",
    silver: "#C0C0C0",
    pink: "#E2006A",
  },
  unit: 15,
  fonts: {
    big: {
      fontSize: "22px",
      lineHeight: "28px",
      fontWeight: "600",
    },
    medium: {
      fontSize: "14px",
      lineHeight: "20px",
      fontWeight: 700,
    },
    small: {
      fontSize: "10px",
      lineHeight: "14px",
      fontWeight: "normal",
    },
    tablet: {
      big: {
        fontSize: "28px",
        lineHeight: "38px",
        fontWeight: "600",
      },
      medium: {
        fontSize: "21px",
        lineHeight: "25px",
        fontWeight: 700,
      },
      small: {
        fontSize: "14px",
        lineHeight: "18px",
        fontWeight: "normal",
      },
    },
  },
  mediaQueries: {
    desktop: 1240,
    tablet: 768,
    mobile: 560,
  },
};

export default theme;
